import { Component } from '@angular/core';
import { noAccessTranslations } from './no-access.translations';

@Component({
  imports: [],
  templateUrl: './no-access.component.html',
  styles: [
    `
      :host {
        height: 100%;
        background-color: white;
      }
    `,
  ],
})
export class NoAccessComponent {
  readonly translations = noAccessTranslations();
}
